import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class EncoderService {
    private _enc = new TextEncoder();
    private _dec = new TextDecoder();

    public xorEncryptToBase64(plain: string, key: string): string {
        if (!key) throw new Error('empty key');
        const data = this._enc.encode(plain);
        const k = this._enc.encode(key);
        for (let i = 0; i < data.length; i++) data[i] ^= k[i % k.length];
        let bin = '';
        const CH = 0x8000;
        for (let i = 0; i < data.length; i += CH) {
            const sub = data.subarray(i, i + CH);
            bin += String.fromCharCode.apply(null, Array.from(sub));
        }
        return btoa(bin);
    }

    public xorDecryptFromBase64(b64: string, key: string): string {
        if (!key) throw new Error('empty key');
        const bin = atob(b64);
        const data = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) data[i] = bin.charCodeAt(i);
        const k = this._enc.encode(key);
        for (let i = 0; i < data.length; i++) data[i] ^= k[i % k.length];
        return this._dec.decode(data);
    }
};

